import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FileUpload } from 'containers/forms/dashboard'
import { MaterialModal } from 'components/layout'

export default class FileUploadModal extends Component {
  static propTypes = {
    colorClass: PropTypes.string,
    modalId: PropTypes.string,
    category: PropTypes.string
  }

  render() {
    const { colorClass, modalId } = this.props

    return (
      <MaterialModal.Body
        id={modalId}
        colorClass={colorClass}
        title="File upload"
        titleKey="moduleTitle.file_upload"
      >
        <MaterialModal.Content>
          <FileUpload {...this.props} />
        </MaterialModal.Content>
      </MaterialModal.Body>
    )
  }
}
